<template>
  <div class="column">
    <breadcrumbs></breadcrumbs>
    <title-block :title="'Project Info'" :callback="GetOrRefreshData"></title-block>
    <section ref="infoProjectRef">
      <b-field label="Naam">
        <b-input type="text" v-model="name" required></b-input>
      </b-field>
      <b-field label="Adres">
        <b-input type="text" v-model="address" required></b-input>
      </b-field>
      <b-field label="Stad">
        <b-input type="text" v-model="city" required></b-input>
      </b-field>
      <b-field label="Postcode">
        <b-input
          v-model="zipCode"
          pattern="[1-9][0-9]{3}[A-Z]{2}"
          type="textArea"
          placeholder="Postcode"
          required
          oninvalid="this.setCustomValidity('Postcode Format is 1234AA')"
          onchange="this.setCustomValidity('')"
        ></b-input>
      </b-field>
      <b-field label="Land">
        <b-select placeholder="Land" icon="globe" icon-pack="fas" v-model="countryCode" expanded required>
          <option value="nl">Nederland</option>
        </b-select>
      </b-field>
      <div class="field" v-if="admin">
        <div class="field-body">
          <div class="field has-addons">
            <p class="control">
              <a class="button" @click="GetOrRefreshData">
                <div class="svg-icon svg-baseline pointer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                    <path
                      d="M43.3 28.2v.1q-1.6 7-7 11.4Q31 44 24 44q-3.8 0-7.4-1.4-3.5-1.5-6.3-4.1l-3.4 3.3q-.5.5-1.1.5-.7 0-1.2-.5T4 40.7V29q0-.7.5-1.2t1.2-.5h11.6q.7 0 1.2.5T19 29q0 .7-.5 1.2L15 33.7q1.9 1.8 4.2 2.7 2.4 1 4.9 1 3.5 0 6.5-1.8 3-1.7 4.9-4.6l1.3-3q.2-.7.8-.7h5q.4 0 .6.3.2.2.2.6zM44 7.3V19q0 .7-.5 1.2t-1.2.5H30.7q-.7 0-1.2-.5T29 19q0-.7.5-1.2l3.6-3.6q-3.9-3.5-9.1-3.5-3.5 0-6.5 1.7T12.6 17l-1.3 3q-.2.7-.8.7H5.3q-.3 0-.6-.3-.2-.2-.2-.6v-.1q1.7-7 7-11.4Q16.8 4 24 4q3.8 0 7.4 1.4Q35 7 37.8 9.5l3.4-3.3q.5-.5 1.1-.5.7 0 1.2.5t.5 1.1z"
                      fill="#8da3ac"
                    ></path>
                  </svg>
                </div>
                <span>Reset</span>
              </a>
            </p>

            <p class="control">
              <a class="button is-success" @click="saveChanges()">
                <span class="icon is-small">
                  <i class="fas fa-check"></i>
                </span>
                <span>Wijzig</span>
              </a>
            </p>
          </div>
          <!-- <div class="field is-right">
            <div class="buttons is-right">
              <a class="button is-danger" @click="deleteProject()">
                <span class="icon is-small">
                  <i class="fas fa-times"></i>
                </span>
                <span>Verwijder Project</span>
              </a>
            </div>
          </div> -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/General/Breadcrumbs'
import TitleBlock from '@/components/General/TitleBlock'
import { mapGetters, mapActions } from 'vuex'
import ProjectService from '@/services/projectService'
import rmBtnMixin from '@/mixins/rmBtnMixin.js'
export default {
  components: {
    Breadcrumbs,
    TitleBlock
  },
  mixins: [rmBtnMixin],
  data() {
    return {
      name: '',
      countryCode: 1,
      city: '',
      zipCode: '',
      address: '',
      countries: ['Nederland'],
      admin: false
    }
  },
  computed: {
    ...mapGetters(['project', 'user', 'adminClaim'])
  },
  mounted() {
    this.GetOrRefreshData()
  },
  methods: {
    GetOrRefreshData() {
      this.checkAdmin()
      this.name = this.project.name
      this.city = this.project.city
      this.address = this.project.address
      this.zipCode = this.project.zipCode
      this.countryCode = this.project.countryCode
    },
    async saveChanges() {
      const pref = this.$refs.infoProjectRef.getElementsByTagName('input')
      let hasError = false
      for (let i = 0; i < pref.length; i++) {
        if (!pref[i].validity.valid) {
          hasError = true
        }
      }
      if (!hasError) {
        const newProjectData = this.project
        newProjectData.name = this.name
        newProjectData.city = this.city
        newProjectData.address = this.address
        newProjectData.zipCode = this.zipCode
        newProjectData.countryCode = this.countryCode
        this.$store.dispatch('updateSelectedProject', newProjectData)
      }
    },
    async deleteProject() {
      const res = await this.deleteAlert('Project')
      if (res == 'deleted') {
        // remove before flight
        await this.$store.dispatch('deleteProject', this.project.projectId)
        this.$router.push('/projectlist/')
      }
    },
    async checkAdmin() {
      let bool = false
      bool = await this.$store.dispatch('getProjectAdminClaim', this.project.projectId)
      this.admin = bool
    }
  }
}
</script>

<style lang="scss" scoped>
.svg-icon {
  margin-left: -2px;
  margin-right: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/Projects/InfoProject.vue